<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PROC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              :selected="batchJobHistorySearchBox.batchJobSuccessYn"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
              sticky
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_Scr"
              @click="onSearch"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :dataset="'dsBatchJob'"
        :columns="gridColumns0"
        :showDisplayCountControl="false"
        :initialPagesize="5"
        :multiselect="false"
      />
      <div class="btn_moreView">
        <p
          :class="pageing.totalCount === 0 || pageing.count === pageing.totalCount ? 'disabled' : ''"
          @click="onAddList"
        >
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CLOSE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00004_P03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00004',
    },
    batchJobId: {
      type: String,
      required: true,
      validator(value) {
        return (utils.isEmpty(value) === false);
      },
    },
  },
  data() {
    return {
      isPageing: false,
      pageing: {
        pagePerCount: 1000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },

      // 더보기 SearchBox
      showMoreSearchBox: {},

      batchJobHistorySearchBox: {
        batchJobId: '',
        batchJobSuccessYn: { key: '', label: '' },
        batchJobStartDTM: '',
        batchJobEndDTM: '',
      },

      rangeDate: {
        from: utils.now('YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_BCJB_PRTC_ID'),
        datafield: 'batchJobPracticeId',
        width: '330px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsBatchJob, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PROC_DTM'),
        datafield: 'batchJobGenerateDTM',
        width: '150px',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsBatchJob, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }, {
        text: this.$t('MSG_TXT_PROC_YN'),
        datafield: 'batchJobSuccessYn',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ERR_CD'),
        datafield: 'batchJobErrorCode',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ERR_CNTN'),
        datafield: 'batchJobErrorContent',
      }, {
        text: this.$t('MSG_TXT_PRTC_CNTN'),
        datafield: 'batchJobPracticeContent',
      }],
    };
  },
  datasets: [{
    id: 'dsBatchJob',
    type: 'local',
    data: 'localdata0',
    datafields: [],
  }],
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    showMoreCount() {
      return `(${this.pageing.count}/${this.pageing.totalCount})`;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {

  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    // 내부 함수 기술
    // 이벤트 핸들러 기술, prefix on 적용
    onGridButtonClicked(btn, rowData) {
      utils.openLayerPopup('PGE_CMS_00007', this.onPagePopupClose, {
        pageInitialData: {
          batchJobId: rowData.batchJobId,
          batchJobHistoryUID: rowData.batchJobHistoryUID,
        },
        size: 'md',
      });
    },
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onResetClick() {
      this.batchJobHistorySearchBox.batchJobSuccessYn.key = 'ALL';

      this.batchJobHistorySearchBox.batchJobStartDTM = '';
      this.batchJobHistorySearchBox.batchJobEndDTM = '';
      this.rangeDate = {
        from: utils.now('YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      };
    },
    onSearch() {
      // date picker validation
      if (this.onClickValidate()) return false;

      this.pageing.currentPage = 1;
      this.pageing.totalCount = 0;
      this.pageing.count = 0;

      this.dsBatchJob.setRawData([]);

      this.setShowMoreSearchBox(this.batchJobId);
      this.searchBatchJobHistory();

      return null;
    },
    onClose() {
      this.$emit('close');
    },
    onPagePopupClose() {
    },
    onAddList() {
      // 더보기
      if (this.isPageing) {
        this.pageing.currentPage += 1;
        this.searchBatchJobHistory();
      }
    },
    /** ***************************************************************************
      함수 영역
      ***************************************************************************** */
    setDatePickerToSearchBox() {
      if (this.rangeDate.from != null && this.rangeDate.from !== '') {
        this.batchJobHistorySearchBox.batchJobStartDTM = utils.dateformatToServer(this.rangeDate.from);
      }

      if (this.rangeDate.to != null && this.rangeDate.to !== '') {
        this.batchJobHistorySearchBox.batchJobEndDTM = `${utils.dateformatToServer(this.rangeDate.to).substring(0, 8)}235959`;
      }
    },

    setShowMoreSearchBox(sBatchJobId) {
      this.setDatePickerToSearchBox();
      this.batchJobHistorySearchBox.batchJobId = utils.trim(sBatchJobId);
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.batchJobHistorySearchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      this.showMoreSearchBox = queryParams;
    },

    searchBatchJobHistory() {
      // 더보기 클릭시 기존 searchBox 값 유지를 위해 위치 변경 ()
      // this.setDatePickerToSearchBox();
      // this.batchJobHistorySearchBox.batchJobId = utils.trim(sBatchJobId);
      // // searchBox -> paramsObj변환 { key : value, key : value }
      // const queryParams = utils.reduce(this.batchJobHistorySearchBox, (result, value, key) => {
      //   const objResult = utils.clone(result);
      //   if (utils.isUndefined(value) === false && value !== null) {
      //     objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
      //   }
      //   return objResult;
      // }, {});

      const queryParams = utils.cloneDeep(this.showMoreSearchBox);
      // pageing
      utils.assign(queryParams, { pagePerCount: this.pageing.pagePerCount });
      utils.assign(queryParams, { currentPage: this.pageing.currentPage });

      http.request(this.pageId, 'DTS_CMS_00016', {
        query: queryParams,
      }).then(res => {
        if (utils.isUndefined(res.data) === false && res.data.length === this.pageing.pagePerCount) {
          this.isPageing = true;
        } else {
          this.isPageing = false;
        }

        utils.forEach(res.data, item => {
          const objItem = item;
          objItem.batchJobPracticeId = [
            { key: item.batchJobPracticeId, label: item.batchJobPracticeId, type: 'sublink' },
          ];
        });

        const union = utils.mergeArray(this.dsBatchJob.data, res.data);
        this.dsBatchJob.setRawData(union);

        this.pageing.count = this.dsBatchJob.data.length;
        if (res.data.length > 0) {
          this.pageing.totalCount = res.data[0].totalCount;
        }
      }).catch(error => {
        console.log(error);
      });
    },

    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
